import React from "react";
import { connect } from "react-redux";
import { withScriptjs } from "react-google-maps";
import { Field, change } from "redux-form";
import { StandaloneSearchBox } from "react-google-maps/lib/components/places/StandaloneSearchBox";
import { Input, LiveSearch } from "Components/Form";
import { GOOGLE_MAPS_API_KEY } from "../../constants";

// this is a drop in google search input
// it sets lat, lng & props.name in the form specified by props.formId
// props.onPlaceFound is a callback for any additional needs upon location selection

let HotelGroup = ({formId, change, onGroupSelected, fieldClassName}) => {

  return (
    <LiveSearch
      id="group-search"
      formId={formId}
      url={`${window.API}/hotel-groups/quick`}
      onSelect={result => {
        change(formId, 'group', result.id)
        change(formId, 'groupName', result.text)
        onGroupSelected();
      }}
      label="Hotel Groups"
      labelClassName="sr-only"
      name="groupName"
      placeholder="Hotel Group name"
      fieldClassName={fieldClassName ? fieldClassName : 'w-full'}
      wrapperClassName="mb-0"
      noBottom
      onClear={() => {
        change(formId, 'group', null)
        change(formId, 'groupName', null)
        onGroupSelected();
      }}
      getText={item => item.display_name}
    />
  )


}
export default connect(null, { change })(HotelGroup);
